import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/logo268v.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-d9d15a64")

_pushScopeId("data-v-d9d15a64")
const _hoisted_1 = { class: "tocV3_headTip" }
const _hoisted_2 = { class: "tocV3_topText" }
const _hoisted_3 = { class: "tocV3_topText_flex" }
const _hoisted_4 = {
  key: 0,
  class: "brandlogo_wrapper"
}
const _hoisted_5 = { class: "tocV3_topText_one" }
const _hoisted_6 = { class: "ptb5" }
const _hoisted_7 = {
  key: 0,
  class: "productname_wrapper productname_bg productname_bg_699"
}
const _hoisted_8 = { class: "tocV3_topText_small" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "tocV3_topText_small_shallow" }, "*车型信息仅供参考，请以实车为准", -1)
const _hoisted_10 = { class: "head_promise_result_wrap" }
const _hoisted_11 = { class: "head_promise_wrapper" }
const _hoisted_12 = { class: "vector_description" }
const _hoisted_13 = { class: "result_wrap" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "result_description" }, " 268V 检测标准符合GB/T 30323-2013国家标准和 CADA 团体标准，且本公司获 ISO 9001质量管理体系认证 ", -1)
const _hoisted_15 = { class: "circle" }
const _hoisted_16 = { class: "circleItemSlot" }
const _hoisted_17 = { class: "errNum" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("/")
const _hoisted_19 = { class: "totalNum" }
const _hoisted_20 = { class: "circleItemTxt" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "divide_line" }, null, -1)
const _hoisted_22 = { class: "result_bottom" }
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  class: "localIcon",
  src: _imports_0
}, null, -1)
const _hoisted_24 = { class: "toc_ui__headTip_content_report_num" }
const _hoisted_25 = { class: "buyCarTip" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_circleCom = _resolveComponent("circleCom")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.state.brandLogo && _ctx.state.brandLogo.length)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("img", {
                  src: _ctx.state.brandLogo,
                  class: "tocV3_topText_brandlogo"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.state.seriesName.includes(_ctx.state.brandName) ? _ctx.state.seriesName : `${_ctx.state.brandName} ${_ctx.state.seriesName}`), 1),
          _createVNode("div", _hoisted_6, [
            (_ctx.state.productName && _ctx.state.productName.length)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode("span", {
                    class: "productname_font productname productname_699",
                    text: _ctx.state.productName
                  }, _toDisplayString(_ctx.state.productName), 9, ["text"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_8, "VIN: " + _toDisplayString(_ctx.state.vin), 1),
        _hoisted_9
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", {
          class: ["head_promise_bg", _ctx.getHeadPromiseBgStyle()]
        }, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("img", {
                class: "vector",
                src: _ctx.getVectorIcon(),
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("span", {
                class: ["promiseMsg", _ctx.getPromiseMsgFont()],
                text: _ctx.state.promiseMsg
              }, _toDisplayString(_ctx.state.promiseMsg), 11, ["text"])
            ])
          ])
        ], 2),
        _createVNode("div", {
          class: ["head_result_bg", _ctx.getHeadResultBgStyle()]
        }, [
          _createVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode("div", _hoisted_15, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.blueCircleList, (item) => {
                return (_openBlock(), _createBlock("div", {
                  class: "circleItem",
                  key: item.name,
                  onClick: ($event: any) => (_ctx.clickTab(item.clickToId))
                }, [
                  _createVNode(_component_circleCom, {
                    strokeWidth: _ctx.state.blueCircleWidth,
                    currentGradient: _ctx.state.blueCircle,
                    progress: _ctx.setProgress(item),
                    circleId: item.name
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_16, [
                        _createVNode("span", _hoisted_17, _toDisplayString(item.error), 1),
                        _hoisted_18,
                        _createVNode("span", _hoisted_19, _toDisplayString(item.total), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["strokeWidth", "currentGradient", "progress", "circleId"]),
                  _createVNode("div", _hoisted_20, _toDisplayString(item.nameTxt), 1)
                ], 8, ["onClick"]))
              }), 128))
            ]),
            _hoisted_21,
            _createVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode("span", _hoisted_24, " NO." + _toDisplayString(_ctx.state.reportCode) + " " + _toDisplayString(_ctx.state.reportGenDate ? `| ${_ctx.state.reportGenDate.replace(/-/g,'.')}` : ''), 1)
            ])
          ])
        ], 2),
        _createVNode(_component_van_popup, {
          show: _ctx.state.showProtect,
          "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.showProtect = $event)),
          round: "",
          position: "bottom"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_25, [
              _createVNode("p", {
                class: "buyCarTipItem",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toExplain('check')))
              }, _toDisplayString(_ctx.state.showPromiseDes), 1),
              (_ctx.state.reportMsg.RpSRZ())
                ? (_openBlock(), _createBlock("p", {
                    key: 0,
                    class: "buyCarTipItem",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toExplain('auth')))
                  }, " 查看《付费享1年3万公里保修说明》 "))
                : _createCommentVNode("", true),
              _createVNode("p", {
                class: "canbutton",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setShowProtect()))
              }, "取消")
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ])
  ]))
})